/**
 * ATTENTION! This file is auto-generated for the 'tasks' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import type { TaskRepository } from '../server/repositories/TaskRepository';
import type { TaskStatusRepository } from '../server/repositories/TaskStatusRepository';
import type { TaskTypeRepository } from '../server/repositories/TaskTypeRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type TaskRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TaskRepository>;
export function useTaskRepository(): TaskRepositoryClient { return makeRepositoryProxy<TaskRepositoryClient>('tasks::TaskRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTaskRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const taskRepository = useTaskRepository();

type TaskStatusRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TaskStatusRepository>;
export function useTaskStatusRepository(): TaskStatusRepositoryClient { return makeRepositoryProxy<TaskStatusRepositoryClient>('tasks::TaskStatusRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTaskStatusRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const taskStatusRepository = useTaskStatusRepository();

type TaskTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TaskTypeRepository>;
export function useTaskTypeRepository(): TaskTypeRepositoryClient { return makeRepositoryProxy<TaskTypeRepositoryClient>('tasks::TaskTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTaskTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const taskTypeRepository = useTaskTypeRepository();
